import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnResizeBar from "@shared/components/SnResizeBar";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_MPI_REG_002_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      getOkayData: () => {
        return {
          rtnData: [
            gridRefs.current["grid1"].current?.getCheckedRows() || [],
            gridRefs.current["grid2"].current?.getCheckedRows() || [],
          ],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_MPI_REG_002_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mtl_mpi_reg_002_pop_001_01",
          params: searchRef.current.getFormdata(),
        };
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });
      } catch (error: any) {}
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkedRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkedRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div
            style={{
              height: "55vh",
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <SnResizeBar direction={"height"} id="panel1" orgSize="40%">
              <SnGrid
                ref={gridRefs.current["grid1"]}
                columnConfig={grids.grid1.columns}
                rowData={grids.grid1.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                  ischeckboxSelection: true,
                }}
                events={grids.grid1.events}
                filter={{
                  refs: [gridRefs.current["grid2"]],
                  columns: ["no_req"],
                }}
              />
            </SnResizeBar>
            <SnResizeBar direction={"height"} id="panel2" orgSize="60%">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                  ischeckboxSelection: true,
                }}
                events={grids.grid2.events}
              />
            </SnResizeBar>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_MPI_REG_002_POP_001;
